import DetailsWrapper from './DetailsWrapper';
export default DetailsWrapper;
